// extracted by mini-css-extract-plugin
module.exports = {"chatBlock":"ChatBlock_chatBlock__19v2j","chatBlockMessage":"ChatBlock_chatBlockMessage__2XlMY"};